import React, { memo } from 'react';
import { BrowserRouter, Routes as Switch, Route } from 'react-router-dom';
import { ErrorBoundary } from '../../../components/molecules';
// import { WebSocketController } from "../../../controllers";
import {
  Home,
  About,
  Login,
  EmailConfirm,
  EsqueciSenha,
  PageNotFound,
  ChangePassword
} from '../../../pagesPublic';
import { Notificacoes, Dashboard, Arquivos } from '../../../pages';
import EmpresasRoutes from './EmpresasRoutes';
import CalculadorasRoutes from './CalculadorasRoutes';
import CorrelacoesRoutes from './CorrelacoesRoutes';
import CarteirasAbertasRoutes from './CarteirasAbertasRoutes';
import ConfigRoutes from './ConfigRoutes';
import CarteirasRoutes from './CarteirasRoutes';
import PortfoliosRoutes from './PortfoliosRoutes';
import AtivosRoutes from './AtivosRoutes';
import IndicadoresRoutes from './IndicadoresRoutes';
import ReportsRoutes from './ReportsRoutes';
import MercadosRoutes from './MercadosRoutes';
import AvaliacoesRoutes from './AvaliacoesRoutes';

import { PATHS } from '../../../enums';

import PrivateSession from '../PrivateSession';
import PublicSession from '../PublicSession';

const Routes = memo(props => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Switch>
          <Route exact path={`${PATHS.login.path}/:username`} element={<Login />} />
          <Route exact path={PATHS.login.path} element={<Login />} />
          <Route exact path={PATHS['email-confirm'].path} element={<EmailConfirm />} />
          <Route exact path={PATHS['change-password'].path} element={<ChangePassword />} />
          <Route exact path={PATHS['esqueci-senha'].path} element={<EsqueciSenha />} />
          <Route
            exact
            path={PATHS.home.path}
            element={
              <PublicSession>
                <Home />
              </PublicSession>
            }
          />
          <Route
            exact
            path={PATHS.sobre.path}
            element={
              <PublicSession>
                <About />
              </PublicSession>
            }
          />
          <Route
            exact
            path={PATHS.dashboard.path}
            element={
              <PrivateSession>
                <Dashboard />
              </PrivateSession>
            }
          />
          <Route
            exact
            path={`${PATHS.empresas.path}/*`}
            element={
              <PublicSession>
                <EmpresasRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}/*`}
            element={
              <PublicSession>
                <AtivosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.indicadores.path}/*`}
            element={
              <PublicSession>
                <IndicadoresRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.correlacoes.path}/*`}
            element={
              <PublicSession>
                <CorrelacoesRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.prv.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.fnd.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
                {/* <AtivosRoutes /> */}
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.tpu.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.tpr.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.tba.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.acn.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.dri.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.crp.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.moe.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.bem.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.cbl.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.ativos.path}${PATHS.etf.path}/*`}
            element={
              <PublicSession>
                <MercadosRoutes />
              </PublicSession>
            }
          />
          <Route
            exact
            path={`${PATHS.calculadoras.path}/*`}
            element={
              <PublicSession>
                <CalculadorasRoutes />
              </PublicSession>
            }
          />
          <Route
            path={`${PATHS.configuracoes.path}/*`}
            element={
              <PrivateSession>
                <ConfigRoutes />
              </PrivateSession>
            }
          />
          <Route
            path={PATHS.notificacoes.path}
            element={
              <PrivateSession>
                <Notificacoes />
              </PrivateSession>
            }
          />
          <Route
            path={`${PATHS.portfolios.path}/*`}
            element={
              <PrivateSession>
                <PortfoliosRoutes />
              </PrivateSession>
            }
          />
          <Route
            path={`${PATHS.avaliacoes.path}/*`}
            element={
              <PrivateSession>
                <AvaliacoesRoutes />
              </PrivateSession>
            }
          />
          <Route
            path={`${PATHS.carteiras.path}/*`}
            element={
              <PrivateSession>
                <CarteirasRoutes />
              </PrivateSession>
            }
          />
          <Route
            path={`${PATHS['reports'].path}/*`}
            element={
              <PrivateSession>
                <ReportsRoutes />
              </PrivateSession>
            }
          />
          <Route
            path={PATHS.uploads.path}
            element={
              <PrivateSession>
                <Arquivos />
              </PrivateSession>
            }
          />
          <Route
            path="*"
            element={
              <PublicSession>
                <PageNotFound />
              </PublicSession>
            }
          />
        </Switch>
      </BrowserRouter>
    </ErrorBoundary>
  );
});

Routes.displayName = 'Routes';

export default Routes;
